import { render, staticRenderFns } from "./detailedit.vue?vue&type=template&id=0e2340fe&scoped=true"
import script from "./detailedit.vue?vue&type=script&lang=ts"
export * from "./detailedit.vue?vue&type=script&lang=ts"
import style0 from "./detailedit.vue?vue&type=style&index=0&id=0e2340fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e2340fe",
  null
  
)

export default component.exports